/**
 * Centralised Amazon Pay New Relic events.
 *
 * All transient NR metrics for the Amazon Pay SDK flow live here so they can
 * be removed in one shot once the release is stable.
 */
import { recordNREvent, NEWRELIC_TABLES } from "@swiggy-private/checkout-core";

import { APAY_NB_CALL_STATUS } from "@payment-client/constants/AmazonPay";

const EVENT_TYPE = NEWRELIC_TABLES.AMAZON_PAY_SDK_UPGRADE_NR_EVENTS;

export function recordBalanceNotInGPO(): void {
    recordNREvent({
        eventType: EVENT_TYPE,
        state: "BALANCE_NOT_IN_GPO",
    });
}

export function recordLinkWalletNBResponse(status: string): void {
    recordNREvent({
        eventType: EVENT_TYPE,
        state: "LINK_WALLET_NB_RESPONSE",
        nbStatus: status,
    });
}

export function recordNativeBridgeCall(params: {
    nbState: string;
    isNewSdk: boolean;
    status: APAY_NB_CALL_STATUS;
    latencyMs?: number;
    extra?: Record<string, string>;
}): void {
    recordNREvent({
        eventType: EVENT_TYPE,
        state: "NB_CALL",
        nbState: params.nbState,
        isNewSdk: String(params.isNewSdk),
        status: params.status,
        ...(params.latencyMs != null ? { latencyMs: String(params.latencyMs) } : {}),
        ...(params.extra || {}),
    });
}

export function recordStateInvalidation(reason: string): void {
    recordNREvent({
        eventType: EVENT_TYPE,
        state: "STATE_INVALIDATION",
        reason,
    });
}

export function recordNewSdkFlowEvent(flowStep: string, extra?: Record<string, string>): void {
    recordNREvent({
        eventType: EVENT_TYPE,
        state: flowStep,
        ...(extra || {}),
    });
}

export function recordLinkingFailed(extra?: Record<string, string>): void {
    recordNREvent({
        eventType: EVENT_TYPE,
        state: "LINKING_FAILED",
        ...(extra || {}),
    });
}

export function recordKeyFactsClick(): void {
    recordNREvent({
        eventType: EVENT_TYPE,
        state: "KEY_FACTS_CLICK",
    });
}

export function recordAplTurboWidgetDecision(params: {
    hide: boolean;
    reason: string;
    extra?: Record<string, string>;
}): void {
    recordNREvent({
        eventType: EVENT_TYPE,
        state: "APL_TURBO_WIDGET",
        hide: String(params.hide),
        reason: params.reason,
        ...(params.extra || {}),
    });
}
